import { useTranslation } from "react-i18next";

// تلميح تفاعلي محسَّن: نقاط ملوّنة + توزيع مسافات أفضل + سطر النسبة مميّز بلون البراند.
export const ChartTooltip = ({ active, payload, label }) => {
  const { t } = useTranslation();
  if (!active || !payload?.length) return null;
  const row = payload[0].payload;
  const items = [
    { key: "present", tone: "bg-emerald-500", label: t("dashboard.present"), value: row.present },
    { key: "late",    tone: "bg-amber-500",   label: t("check.late"),        value: row.late },
    { key: "absent",  tone: "bg-rose-500",    label: t("dashboard.absent"),  value: row.absent },
  ];
  return (
    <div className="min-w-[176px] rounded-2xl border border-border/60 bg-popover/95 px-3.5 py-2.5 shadow-neu backdrop-blur-xl"
         data-testid="chart-tooltip">
      <p className="num font-mono text-[11px] font-black text-muted-foreground" dir="ltr">{label}</p>
      <ul className="mt-2 grid gap-1.5">
        {items.map((it) => (
          <li key={it.key} className="flex items-center justify-between gap-4 text-[13px]">
            <span className="inline-flex items-center gap-2 font-bold text-foreground">
              <span className={`h-2 w-2 rounded-full ${it.tone}`} />
              {it.label}
            </span>
            <span className="num font-mono font-black">{it.value}</span>
          </li>
        ))}
      </ul>
      <p className="mt-2 flex items-center justify-between border-t border-border/50 pt-2 text-[11px] font-bold text-muted-foreground">
        <span>{t("dashboard.rate")}</span>
        <span className="num font-mono text-primary">{row.rate}%</span>
      </p>
    </div>
  );
};
